<template>
    <div class="white-bg">
        <top-carousel></top-carousel>
        <div>
            <div class="body-nav">
                <div class="nav-area">
                    <ul
                        class="ul-nav page-width container main-content"
                        id="tabs"
                    >
                        <li id="3"  class="active">可视化数字工厂</li>
                        <li id="5">能源管理系统</li>
                        <li id="1">智慧运维</li>
                        <li id="7">智能巡检系统</li>
                        <li id="6">综合显示信息系统</li>
                        <li id="4">实验室信息管理系统</li>
                    </ul>
                    <!-- <apply-product></apply-product> -->
                </div>
            </div>
            <div class="tab-area">
                <visual-digital-factory></visual-digital-factory>
                <energy-manage></energy-manage>
                <soms></soms>
                <intelligent-inspection></intelligent-inspection>
                <information-display></information-display>
                <lims></lims>
            </div>
        </div>
    </div>
</template>

<script>
import Lims from './lims'
import Soms from './soms'
import $ from 'jquery'
import applyProduct from './applyProduct'
import soms from './soms'
import visualDigitalFactory from './visualDigitalFactory.vue'
import lims from './lims.vue'
import energyManage from './energyManage.vue'
import InformationDisplay from './InformationDisplay'
import intelligentInspection from './intelligentInspection'
export default {
    components: {
    Lims,
        Soms,
        applyProduct,
        soms,
        visualDigitalFactory,
        lims,
        energyManage,
        InformationDisplay,
        intelligentInspection
    },
    methods: {
        toggleTab() {
            $('#tabs').on('click', 'li', function () {
                $(this).addClass('active').siblings().removeClass('active')
                var id = this.id
                $('#tab' + id)
                    .show()
                    .siblings()
                    .hide()
            })
        },
    },
    mounted() {
        this.toggleTab()
    },
}
</script>

<style scoped lang="less">
@import './softProduct.less';
</style>
